export interface AvailabilityRow {
  product: string;
  stage: string;
  availableTo: string;
  worksNow: string;
  remains: string;
}

/**
 * The availability matrix on /product. Every cell is a plain-language
 * restatement of evidence already documented elsewhere on the site (see
 * `products.ts`, `/agent-user-interface`, `/marketplace`) — never a new,
 * unverified claim invented for this table alone.
 */
export const availabilityMatrix: AvailabilityRow[] = [
  {
    product: "Devory Platform",
    stage: "Foundations substantially implemented",
    availableTo: "Internal pilot",
    worksNow: "Graph composition, component and capability modelling, typed interfaces",
    remains: "Full end-to-end integration and pilot qualification",
  },
  {
    product: "Devory Desktop",
    stage: "Active integration",
    availableTo: "Internal pilot",
    worksNow: "Local projects, native graph workspace, local persistence",
    remains: "Every Cloud-connected workflow completed end to end",
  },
  {
    product: "Devory Cloud",
    stage: "Public Release 0.1 — live",
    availableTo: "Everyone — public self-serve sign-up",
    worksNow: "Self-serve sign-up/sign-in, real organisations and workspaces, Stripe billing, scoped cloud-workflow execution, Marketplace browsing",
    remains: "Broader workflow/component coverage; execution beyond the current safe component set",
  },
  {
    product: "Devory Runtime",
    stage: "Local foundations implemented",
    availableTo: "Internal pilot",
    worksNow: "Planning, scheduling, real subprocess execution, journalling",
    remains: "Full Cloud submission and production operational qualification",
  },
  {
    product: "Devory Autonomous User Interface",
    stage: "Protocol foundation implemented",
    availableTo: "Not externally connectable yet",
    worksNow: "Capability discovery, resource scopes, confirmation, audit envelopes",
    remains: "An externally reachable network transport; external pilot integration",
  },
  {
    product: "Devory Marketplace",
    stage: "Live pipeline, catalogue still empty",
    availableTo: "Everyone — browsing is public; publishing requires a Devory account",
    worksNow: "Real publisher accounts, listings and moderation, entitlement-gated orders and commission accounting",
    remains: "A populated public catalogue — no listings are published yet; broader install experience",
  },
];
